import Vue from "vue";
import Router from "vue-router";
import Hochzeit from "../views/Hochzeit.vue";

Vue.use(Router);

const SanwitchConst = {
  path: "/sandwitch",
  name: "Sandwitch",
  component: () => import("../views/vSandwitch.vue")
};
const HomeConst = {
  path: "/Home",
  name: "Home",
  component: () => import("../views/Home.vue")
};
const HochzeitConst = {
  path: "/",
  name: "Hochzeit",
  component: Hochzeit
};
const AnfahrtConst = {
  path: "/anfahrt",
  name: "Anfahrt",
  component: () => import("../views/vAnfahrt.vue")
};
const TechConst = {
  path: "/Tech",
  name: "tech",
  component: () => import("../views/vTech.vue")
};
const AboutConst = {
  path: "/disclaimer",
  name: "Disclaimer",
  component: () => import("../views/Disclaimer.vue")
};

const EnglishConst = {
  path: "/eng",
  name: "Eng",
  component: () => import("../views/vEng.vue")
};

const routes = [
  HomeConst,
  HochzeitConst,
  AnfahrtConst,
  TechConst,
  AboutConst,
  SanwitchConst,
  EnglishConst
];

const router = new Router({
  routes
});

export default router;
